<template>
  <div class="bg-white rounded-2xl shadow-md p-6 space-y-4">
    <div class="flex items-center justify-between">
      <h2 class="text-lg font-bold">Service après-vente</h2>
      <StoreConfigurationStatusBadge :configuration-status="store.afterSalesServiceConfigStatus" />
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
      <StackedField label="Atelier de réparation">
        <Selector
          id="repairWorkshop"
          name="repairWorkshop"
          :options="repairWorkshopOptions"
          v-model="formData.repairWorkshop"
        />
      </StackedField>
      <StackedField v-if="formData.repairWorkshop" label="Email atelier de réparation">
        <FormField
          id="repairWorkshopEmail"
          name="repairWorkshopEmail"
          v-model="formData.repairWorkshopEmail"
          placeholder="email@example.com"
        />
      </StackedField>
    </div>
    <div class="flex justify-end gap-x-3">
      <SecondaryButton @click="$emit('previous')">Retour</SecondaryButton>
      <SecondaryButton @click="submit" :loading="saving">Continuer</SecondaryButton>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { StackedField, FormField, Selector, SecondaryButton } from "@estaly/ui";
import StoreConfigurationStatusBadge from "@/components/StoreConfigurationStatusBadge.vue";

export default {
  name: "StoreOnboardingStepAfterSales",
  components: { StackedField, FormField, Selector, SecondaryButton, StoreConfigurationStatusBadge },
  props: { store: { type: Object, required: true } },
  emits: ["step-completed", "previous"],
  data() {
    return {
      saving: false,
      formData: {
        repairWorkshop: this.store.repairWorkshop || false,
        repairWorkshopEmail: this.store.repairWorkshopEmail || "",
      },
      repairWorkshopOptions: [
        { value: true, label: "Oui" },
        { value: false, label: "Non" },
      ],
    };
  },
  watch: {
    "formData.repairWorkshop"(val) {
      if (!val) this.formData.repairWorkshopEmail = "";
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["updateAfterSalesService"]),
    async submit() {
      this.saving = true;
      const response = await this.updateAfterSalesService({
        storeId: this.store.id,
        repairWorkshop: this.formData.repairWorkshop,
        repairWorkshopEmail: this.formData.repairWorkshopEmail,
      });
      this.saving = false;
      if (!response?.success) return;

      await this.notify({ category: "simple", type: "success", title: "Service après-vente enregistré" });
      this.$emit("step-completed");
    },
  },
};
</script>
